import { useCallback } from 'react';

import {
  useCollaborativeDocumentContext,
  useUpdateCollaborativeDocument,
} from '@spotify/confidence-editor-react';

export const UNTITLED_DOCUMENT_TITLE = 'Untitled document';

type CollaborativeDocumentTitle = {
  collaborativeDocument: ReturnType<
    typeof useCollaborativeDocumentContext
  >['collaborativeDocument'];
  documentTitle: string;
  handleTitleChange: (nextTitle: string) => void;
  isUpdatingTitle: boolean;
};

export const useCollaborativeDocumentTitle = (): CollaborativeDocumentTitle => {
  const { collaborativeDocument } = useCollaborativeDocumentContext();
  const { updateCollaborativeDocument, isUpdating } =
    useUpdateCollaborativeDocument({
      onError: 'post-alert',
    });

  const handleTitleChange = useCallback(
    (nextTitle: string) => {
      const currentTitle = collaborativeDocument.title ?? '';

      if (
        nextTitle === currentTitle ||
        (!currentTitle && nextTitle === UNTITLED_DOCUMENT_TITLE)
      ) {
        return;
      }

      updateCollaborativeDocument(
        {
          name: collaborativeDocument.name,
          title: nextTitle,
        },
        'title',
      );
    },
    [collaborativeDocument, updateCollaborativeDocument],
  );

  return {
    collaborativeDocument,
    documentTitle: collaborativeDocument.title || UNTITLED_DOCUMENT_TITLE,
    handleTitleChange,
    isUpdatingTitle: isUpdating,
  };
};
